var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDislikeIconFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.325 13.2158C14.7227 13.2158 14.2276 12.7583 14.1677 12.1719L14.1609 12.0527V3.44141L14.1677 3.32227C14.2274 2.7356 14.7225 2.27734 15.325 2.27734H17.238C17.8805 2.2775 18.4021 2.79888 18.4021 3.44141V12.0527C18.4018 12.695 17.8804 13.2157 17.238 13.2158H15.325Z",
    fill: "#414651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31323 18C7.0018 18 6.21958 16.5384 6.94702 15.4473L8.72828 12.7988H2.4021C1.64515 12.7988 1.15513 11.5478 1.33862 10.8135L2.8894 4.6084C3.23192 3.23866 4.46283 2.27737 5.87476 2.27734H9.38257C9.98985 2.27747 11.4021 2.5 11.4021 2.5L12.5691 2.78125C12.612 2.80994 12.6426 2.85349 12.655 2.90234L12.6609 2.95312V12.7988C12.6608 12.8346 12.6523 12.8703 12.6345 12.9014L9.14917 18H8.31323Z",
    fill: "#414651"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDislikeIconFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dislikeIconFill.f68b252fa4f6c53371a4489555f70d74.svg";